<div class="unauthorized-container">
  <h2>Unauthenticated User</h2>
  <p>User does not have access to application!</p>
</div>